/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var XSquareIcon16Light = forwardRef('XSquareIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M5.199 4.492a.5.5 0 0 0-.707.707l2.3 2.301-2.3 2.301a.5.5 0 0 0 .707.707l2.301-2.3 2.301 2.3a.5.5 0 1 0 .707-.707L8.208 7.5l2.3-2.301a.5.5 0 1 0-.707-.707L7.5 6.792l-2.301-2.3Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 1a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h7a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3H4ZM2 4a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4Z" })));
});
